import type { FraseVista } from "../contratos";
import type { ReactNode } from "react";

import estilos from "./card.module.css";

/** Caminho do app a partir de uma URL da vista, que pode vir absoluta (`base_url`). */
export function caminho(url: string): string {
  if (url.startsWith("/")) return url;
  const u = new URL(url);
  return `${u.pathname}${u.search}`;
}

export function Externo({ href, children }: { href: string; children: ReactNode }) {
  return (
    <a href={href} rel="nofollow noopener">
      {children}
    </a>
  );
}

export function Frases({ frases }: { frases: FraseVista[] }) {
  if (!frases.length) return null;
  return (
    <ul>
      {frases.map((f) => (
        <li key={`${f.url}|${f.texto}`}>
          {f.texto}
          <br />
          <span className={estilos.fonte}>
            Fonte: <Externo href={f.url}>consulta oficial</Externo>, consultada em {f.data}. Trecho:{" "}
            <span className={estilos.trecho}>{f.trecho}</span>
          </span>
        </li>
      ))}
    </ul>
  );
}

/** SVG gerado no servidor (prisma.card.graficos), com `role="img"` e título. */
export function Grafico({ svg }: { svg: string }) {
  return <div dangerouslySetInnerHTML={{ __html: svg }} />;
}

export function Bloco(props: { numero: number; titulo: string; children: ReactNode }) {
  const id = `b${props.numero}`;
  return (
    <section className={estilos.bloco} aria-labelledby={id}>
      <h2 id={id}>
        {props.numero}. {props.titulo}
      </h2>
      {props.children}
    </section>
  );
}
